import { DateRange } from "@material-ui/icons";
import { endOfDay, startOfDay } from "date-fns";
import React from "react";
import DatePicker from "./DatePicker";

function isValidDate(d: Date | null) {
  return d instanceof Date && !Number.isNaN(d.getTime());
}

export interface DateRangePickerProps {
  fromValue: string | null;
  setFromValue: (value: string | null) => void;
  toValue: string | null;
  setToValue: (value: string | null) => void;
  labelFrom?: string;
  labelTo?: string;
  /**
   * Force the helper row not to be displayed.
   * This will suppress the any errors from being shown but will set the height of the component to be only
   * the height of the input; rather than including whitespace for the error/helper message to render in.
   */
  hideHelper?: boolean;
  clearable?: boolean;
}

const DateRangePicker: React.FunctionComponent<DateRangePickerProps> = ({
  fromValue,
  setFromValue,
  toValue,
  setToValue,
  hideHelper,
  clearable,
  labelFrom = "From",
  labelTo = "To",
}) => {
  return (
    <>
      <DatePicker
        value={fromValue}
        maxDate={toValue}
        hideHelper={hideHelper}
        label={labelFrom}
        onChange={(d) => {
          if (isValidDate(d)) {
            setFromValue(startOfDay(d as Date).toISOString());
          }
          if (clearable && !d) {
            setFromValue(null);
          }
        }}
        inputProps={{
          "data-testid": "dateRangePicker.from.input",
        }}
        keyboardIcon={<DateRange color="primary" />}
      />
      <DatePicker
        value={toValue}
        minDate={fromValue}
        hideHelper={hideHelper}
        label={labelTo}
        onChange={(d) => {
          if (isValidDate(d)) {
            setToValue(endOfDay(d as Date).toISOString());
          }
          if (clearable && !d) {
            setToValue(null);
          }
        }}
        inputProps={{
          "data-testid": "dateRangePicker.to.input",
        }}
        keyboardIcon={<DateRange color="primary" />}
      />
    </>
  );
};

export default DateRangePicker;
